(function($) {

	'use strict';

	function init() {
		const searchFalc = $('.searchFalc');

		//Open search bar
		$('.searchFalc__trigger').on('click', e => {
			toggleSearchBar();
			if(searchFalc.hasClass('open') ){
				toggleBurgerMenu();
			}
		});
	};

	function toggleSearchBar(){
		const delay = 200;
		const form = $('.searchFalc__form');
		form.toggleClass('open').slideToggle(delay);
		if( form.hasClass('open') ){
			window.setTimeout(
				() => $('.searchFalc__form input[type="search"]').focus(),
				delay
			);
		}
	}

	$(document).ready(function() {
		init();
	});

})(jQuery);
